export class Parameter {
    name: string;
    displayName?: any;
    type: string;
}

export class Parameters {
    parameter: Parameter[];
}

export class Column {
    name: string;
    displayName: string;
    order: number;
    summarize: boolean;
    sumTitle: string;
}

export class Columns {
    column: Column[];
}

export class DynamicReportItem {
    connection: string;
    name: string;
    query: string;
    parameters: Parameters;
    columns: Columns;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/monitoring/dynamic-report-item.ts